import { Maybe } from '@noshiro/ts-utils';
import { RootObservableClass } from '../class';
export const subject = () => new SourceObservableClass();
export const source = subject; // alias
class SourceObservableClass extends RootObservableClass {
    constructor() {
        super({ type: 'Source', currentValueInit: Maybe.none });
    }
    next(nextValue) {
        if (this.isCompleted)
            return;
        this.startUpdate(nextValue);
    }
}
